import React from 'react';
import '../styles.css';
import * as f from '../logic';
import { TASKS_PER_LEVEL } from '../const';
import { connect } from 'react-redux';
import _ from 'lodash';

function Intro(props) {
  const { level, startLevel, hits } = props;
  const secs = f.levelInfo(level).time / 10;
  const breakneckHits = level === 4 ? hits - (4 - startLevel) * TASKS_PER_LEVEL : 0;

  return (
    <div style={{ display: 'grid', gridArea: '1/1/span 3/2', alignContent: 'center' }}>
      <div className="ms-intro">
        {level === 1 ? (
          <>
            <Item content={`You have •${secs}• seconds to solve each task.`} />
            <Item content="The faster you solve it, the higher your score." />
            <Item content={`Solve •${TASKS_PER_LEVEL}• tasks to clear a level.`} />
            <Item content={`If you make a mistake or miss the •${secs}•-second window, it is called a "strike".`} />
            <Item content="The game is over after three strikes. Good luck!" />{' '}
          </>
        ) : breakneckHits ? (
          <>
            <div style={{ marginBottom: '15px' }}>Congratulations!</div>
            <Item content={`You solved •${breakneckHits}• tasks at BREAKNECK speed.`} />
            <Item content={`Your strike count has been reset.`} />
          </>
        ) : (
          <>
            <div style={{ marginBottom: '15px' }}>Congratulations!</div>
            <Item content={`You have cleared •$${level - 1}• level.`} />
            <Item content={`Your strike count has been reset.`} />
            <Item content={`Next level: •$${level}•`} />
            <Item content={`From now on you have •${secs}• seconds to solve each task.`} />
          </>
        )}
        <div className="ms-start" onClick={props.onStart}>
          {level === 1 ? 'START' : 'CONTINUE'}
        </div>
      </div>
    </div>
  );
}

function mapStateToProps({ ms, common }) {
  return { ...ms, ...common };
}

export default connect(
  mapStateToProps,
  {}
)(Intro);

function Item(props) {
  const text = props.content.toString();
  const runs = _.split(text, '•');

  return (
    <div className="ms-intro-item">
      <span style={{ margin: '0px 10px 0 0' }}>•</span>
      <div>
        {_.map(runs, (run, i) => {
          const levelName = run.startsWith('$');
          const color = i % 2 && !levelName ? 'lime' : 'white';
          const textShadow = levelName ? '0 0 transparent' : '1px 1px black';
          const levelInfo = levelName ? f.levelInfo(run.slice(1)) : null;
          const background = levelInfo ? levelInfo.color : null;
          const padding = levelName ? '2px 7px' : '';

          if (levelName) {
            run = levelInfo.name;
          }

          return (
            <span key={i} style={{ color, textShadow, background, padding }}>
              {run}
            </span>
          );
        })}
      </div>
    </div>
  );
}
